// extracted by css-extract-rspack-plugin
export default {"root":"root-P6RUnq","detailFooterLeftContainer":"detailFooterLeftContainer-y1eT3S","detailFooterRightContainer":"detailFooterRightContainer-jxgR2k"};